module.exports = __webpack_public_path__ + "static/media/red-bg@2x.745e9f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/red-bg@2x.png
// module id = 1772
// module chunks = 0